import { View } from "react-native";
import SettingsCard from "./common/settings-card";
import StyledText from "../../common/ui/styled-text";
import { formatPhoneNumber } from "react-phone-number-input";
import TestCallButton from "../home/test-call-button";
import { useActiveAgent } from "../../../contexts/ActiveAgentContext";
import { MapPin, Phone } from "lucide-react-native";

const AgentIntro = () => {
  const { activeAgent } = useActiveAgent();

  return (
    <SettingsCard title="Location Info">
      <View className="flex flex-row sm:items-center sm:justify-between gap-4">
        <View className="flex flex-col gap-2 flex-1">
          {activeAgent?.address && (
            <View className="flex flex-row items-center gap-2">
              <MapPin size={14} color="#71717A" />
              <StyledText className="text-sm text-gray-600">
                {activeAgent?.address}
              </StyledText>
            </View>
          )}
          {activeAgent?.phoneNumber && (
            <View className="flex flex-row items-center gap-2">
              <Phone size={14} color="#71717A" />
              <StyledText className="text-sm text-gray-600">
                {formatPhoneNumber(activeAgent?.phoneNumber ?? "")}
              </StyledText>
            </View>
          )}
        </View>
        <View className="flex-shrink-0 justify-center">
          <TestCallButton />
        </View>
      </View>
    </SettingsCard>
  );
};

export default AgentIntro;
